import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _Promise from "/app/node_modules/babel-runtime/core-js/promise";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapActions } from "vuex";
import { stepForm } from "~/mixins";
import { v4 } from "uuid";
import Dropzone from "~/components/shared/dropzone";
import loader from "../modals/loader";
export default {
  mixins: [stepForm],
  components: {
    Dropzone: Dropzone,
    loader: loader
  },
  data: function data() {
    var base = this.$router.options.base;
    var token = this.$store.state.user.token;

    return {
      dropZone: "",
      dropzoneOptions: {
        url: base + "api/file-upload",
        // acceptedFiles: ".jpeg,.png,.gif,.doc,.docx,.jpg,.bmp,.pdf,.xls,.xlsm",
        thumbnailWidth: 200,
        maxThumbnailFilesize: 5,
        maxFiles: 16,
        addRemoveLinks: true,
        dictRemoveFile: "Eliminar",
        dictDefaultMessage: " <div class='text__desktop' > <h3 class='dropzone-title'>Arrastra las imagénes aqui</h3> <p  class='dropzone-detail' >Arrastra una imagen desde tu lugar de almacenamiento. doc, docx, jpeg, jpg, png, bmp, pdf, xls, xlsm </p> <span class='dropzone-link' >Seleccionar desde un archivo</span> </div> <div  class='text__responsive' > <h3>Subir archivos o tomar foto<i class='icon-ic-subir-una-imagen' ></i>  </h3> <p class='text__responsive__margin'>Sube un archivo, una imagen o toma una foto con tu dispositivo.</p>  <p>Formatos admitidos: doc, docx, jpeg, jpg, png, bmp, pdf </p>  </div > <div class='text__responsive__active'> <p>Agregar más archivos</p>  </div> ",
        autoProcessQueue: false
      },
      dropZoneActive: false,
      canContinue: false,
      awss3: {
        signingURL: function signingURL(file) {
          return base + "api/aws/s3-signed-url?type=" + file.type + "&ext=" + file.name.split(".").pop();
        },
        headers: { token: token },
        params: {}
      },
      loading: false,
      dropzoneShow: false,
      token: token
    };
  },

  methods: _extends({
    _checkUrl: function _checkUrl(url) {
      if (!url) return "";
      return url.replace(/%2F/g, "\/");
    },
    _loadFiles: function _loadFiles() {
      var _ref = this.$store.state.affiliations.form.membershipRequirements || {},
          url = _ref.url;

      if (!(Array.isArray(url) && url.length && this.$refs.dropzone)) return;

      for (var i = 0; i < url.length; i++) {
        var _url$i = url[i],
            Size = _url$i.Size,
            Name = _url$i.Name,
            Url = _url$i.Url,
            Type = _url$i.Type,
            S3Key = _url$i.S3Key;


        var mockFile = {
          size: Number(Size),
          name: Name,
          type: Type,
          s3ObjectKey: S3Key,
          accepted: true,
          s3ObjectLocation: Url
        };

        if (!Url) continue;

        this.$refs.dropzone.manuallyAddFile(mockFile, Url);
        this.$nextTick(function () {
          if (typeof this.$refs.dropzone !== "undefined") {
            this.canContinue = this.$refs.dropzone.getAcceptedFiles().length >= 2 && this.$refs.dropzone.getAcceptedFiles().length <= 15;
          }
        });
      }
    },
    _mapSapFiles: function _mapSapFiles(files) {
      if (!(Array.isArray(files) && files.length)) return _Promise.resolve([]);
      return _Promise.all(files.filter(function (file) {
        return !file.manuallyAdded;
      }).map(function (file) {
        return new _Promise(function (resolve, reject) {
          var fileReader = new FileReader();
          fileReader.readAsDataURL(file);
          fileReader.onload = function () {
            var encoded = fileReader.result.replace(/^data:(.*;base64,)?/, "");
            if (encoded.length % 4 > 0) encoded += "=".repeat(4 - encoded.length % 4);
            resolve({ base64String: encoded, filename: file.name });
          };
          fileReader.onerror = function (err) {
            return reject(err);
          };
        });
      }));
    }
  }, mapActions({
    saveMembershipRequirements: "affiliations/form/saveMembershipRequirements",
    deleteFileFromS3: "affiliations/form/deleteFileFromS3"
  }), {
    fileAdded: function fileAdded(file) {
      console.log("Viendo file...", file);
      if (!file || !file.name) return;

      if (file.size >= 3000000) {
        this.$refs.dropzone.removeFile(file);
        return this.uploadError(file, "Limite del tamaño del archivo es de 3MB.");
      }

      if (this.$refs.dropzone.getAcceptedFiles().length == 15) {
        this.$refs.dropzone.removeFile(file);
        return this.uploadError(file, "Solo se puede subir 15 archivos como máximo.");
      }

      var extensionArray = ["jpeg", "png", "gif", "doc", "docx", "jpg", "bmp", "pdf", "xls", "xlsm"];

      var extension = file.name.split(".").pop().toLowerCase();

      if (extensionArray.indexOf(extension) !== -1) {
        this.$nextTick(function () {
          if (this.$refs.dropzone) this.$refs.dropzone.processQueue();
        });
        if (extension === "pdf") {
          console.log(file.previewElement.querySelector("img").src = "https://cdn6.aptoide.com/imgs/3/d/b/3db9374db4b24e830cb5c081e2422aa1_icon.png");
        }
        if (extension === "doc" || extension === "docx") {
          console.log(file.previewElement.querySelector("img").src = "https://img.icons8.com/color/452/microsoft-word-2019--v2.png");
        }
        if (extension === "xls" || extension === "xlsm") {
          console.log(file.previewElement.querySelector("img").src = "https://img.icons8.com/color/452/microsoft-excel-2019--v1.png");
        }
        file.id = v4();
        this.dropZoneActive = true;
        // let conditional = this.$ref.dropzone.dropzoneSettings.dictDefaultMessage
        this.isMaxFile();
      } else {
        this.$refs.dropzone.removeFile(file);
        this.$swal("No puedes subir archivos que no sean del tipo ", ".jpeg,.png,.gif,.doc,.docx,.jpg,.bmp,.pdf,.xls,.xlsm", "error");
      }
    },
    success: function success(file, response) {
      this.canContinue = this.$refs.dropzone.getAcceptedFiles().length >= 2 && this.$refs.dropzone.getAcceptedFiles().length <= 15;
      if (response) {
        file.s3ObjectKey = this._checkUrl(response.key);
      }
    },
    sending: function sending(file, xhr, formData) {
      this.dropZoneActive = true;
      this.canContinue = !this.$refs.dropzone.getUploadingFiles().length && !this.$refs.dropzone.getQueuedFiles().length && this.$refs.dropzone.getAcceptedFiles().length >= 2 && this.$refs.dropzone.getAcceptedFiles().length <= 15;

      var files = this.$refs.dropzone.getAcceptedFiles();
      if (files.length > 1) {
        console.log(files);
        var newFiles = files.map(function (_ref2) {
          var name = _ref2.name,
              dataURL = _ref2.dataURL;

          return {
            name: name,
            dataURL: dataURL
          };
        });
        if (files.length === 2) {
          if (newFiles[0].dataURL) {
            if (newFiles[1].dataURL === newFiles[0].dataURL || newFiles[1].name === newFiles[0].name) {
              this.$refs.dropzone.removeFile(files[1]);
              return this.uploadError(files[1], "No puedes subir un archivo que ya cargaste anteriormente.");
            }
          } else {
            if (newFiles[1].name === newFiles[0].name) {
              this.$refs.dropzone.removeFile(files[1]);
              return this.uploadError(files[1], "No puedes subir un archivo que ya cargaste anteriormente.");
            }
          }
        }

        if (files.length === 3) {
          for (var i = 0; i < newFiles.length - 1; i++) {
            var _file = newFiles[i];
            if (newFiles[i].dataURL) {
              if (newFiles[2].dataURL === _file.dataURL || newFiles[2].name === _file.name) {
                this.$refs.dropzone.removeFile(files[2]);
                return this.uploadError(files[2], "No puedes subir un archivo que ya cargaste anteriormente.");
              }
            } else {
              if (newFiles[2].name === _file.name) {
                this.$refs.dropzone.removeFile(files[2]);
                return this.uploadError(files[2], "No puedes subir un archivo que ya cargaste anteriormente.");
              }
            }
          }
        }
      }
    },
    removedFile: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(file, error, xhr) {
        var dropzone;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.isMaxFile();
                dropzone = this.$refs.dropzone;

                if (dropzone) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                this.dropZoneActive = !!dropzone.getAcceptedFiles().length;
                this.canContinue = this.$refs.dropzone.getAcceptedFiles().length >= 2 && this.$refs.dropzone.getAcceptedFiles().length <= 15;

                // if (file.s3ObjectKey) {
                //     try {
                //         debugger
                //         console.log('before remove file from s3')
                //         await this.deleteFileFromS3(file.s3ObjectKey)
                //     } catch (error) {
                //         this.$controlMessage(error)
                //     }
                // }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function removedFile(_x, _x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return removedFile;
    }(),
    uploadError: function uploadError(file, message, xhr) {
      // console.log('uploadError', file, message, xhr)
      console.log("subiendo archivo", message);
      this.$swal("Ocurrió un error al procesar el archivo", message || "", "error");
    },
    s3UploadError: function s3UploadError(error) {
      console.log('s3UploadError', error);
      this.$swal("Ocurrió un error al subir el archivo", error.message || "", "error");
    },
    unauthorizedError: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$swal("Sesión Terminada", "Por favor vuelva a ingresar al sistema", "info").then(function () {
                  location.href = "/";
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unauthorizedError() {
        return _ref4.apply(this, arguments);
      }

      return unauthorizedError;
    }(),
    s3UploadSuccess: function s3UploadSuccess(result) {
      // console.log('s3UploadSuccess', result)
    },
    renameFile: function renameFile(file) {
      // console.log(file)
    },
    isMaxFile: function isMaxFile() {
      this.$refs.dropzone.getAcceptedFiles().length == 15 ? this.dropzoneShow = true : this.dropzoneShow = false;
    },
    submit: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this = this;

        var acceptedFiles, newFiles;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.loading = true;
                this.$refs.loaderModal.showLoader();
                _context3.prev = 2;
                acceptedFiles = this.$refs.dropzone.getAcceptedFiles();
                newFiles = acceptedFiles.map(function (_ref6) {
                  var s3ObjectLocation = _ref6.s3ObjectLocation,
                      s3ObjectKey = _ref6.s3ObjectKey,
                      name = _ref6.name,
                      size = _ref6.size,
                      idMemberShipRequirement = _ref6.idMemberShipRequirement,
                      type = _ref6.type;

                  idMemberShipRequirement = Number(idMemberShipRequirement);
                  if (isNaN(idMemberShipRequirement)) idMemberShipRequirement = 0;
                  return {
                    url: _this._checkUrl(s3ObjectLocation),
                    idMemberShipRequirement: idMemberShipRequirement,
                    size: String(size),
                    name: name,
                    type: type,
                    s3Key: _this._checkUrl(s3ObjectKey)
                  };
                });
                _context3.t0 = this;
                _context3.t1 = newFiles;
                _context3.next = 9;
                return this._mapSapFiles(acceptedFiles);

              case 9:
                _context3.t2 = _context3.sent;
                _context3.t3 = {
                  url: _context3.t1,
                  sapFiles: _context3.t2
                };
                _context3.next = 13;
                return _context3.t0.saveMembershipRequirements.call(_context3.t0, _context3.t3);

              case 13:
                _context3.next = 18;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t4 = _context3["catch"](2);

                this.$controlMessage(_context3.t4);

              case 18:
                this.$refs.loaderModal.closeLoader();
                this.loading = false;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 15]]);
      }));

      function submit() {
        return _ref5.apply(this, arguments);
      }

      return submit;
    }()
  }),
  mounted: function mounted() {
    this.$nextTick(function () {
      this._loadFiles();
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/membership-requirements.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/membership-requirements.vue
// module chunks = 0 1 2 3